import TabsList from './TabsList';
import { TabsListProps, TabsListValueProps } from './types';

export type { TabsListProps, TabsListValueProps };
export default TabsList;
